import { callRpc } from '@/api/resources';

/**
 * Download plot boundaries as one GeoJSON FeatureCollection.
 *
 * The collection is built by `api.fn_plots_geojson`, not in the browser, so the file carries
 * what the server holds - the current approved geometry, WGS84, with the plot's code, farmer
 * and areas as properties - and a plot the caller cannot see is simply not in it. Conservation
 * and hazard features ride along unless `withFeatures` is false.
 */
export async function downloadPlotsGeoJson(plotIds: string[], fileName: string, withFeatures = true): Promise<number> {
  if (plotIds.length === 0) return 0;
  const collection = await callRpc<{ features?: unknown[] }>('fn_plots_geojson', {
    p_plot_ids: plotIds, p_with_features: withFeatures,
  });
  const count = collection?.features?.length ?? 0;
  if (count === 0) return 0;
  const blob = new Blob([JSON.stringify(collection, null, 2)], { type: 'application/geo+json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  // Plot and farmer codes contain '/' (WB/ML/1_P2), which no file system accepts in a name.
  const safe = fileName.replace(/[\\/:*?"<>|]+/g, '-');
  anchor.download = safe.endsWith('.geojson') ? safe : `${safe}.geojson`;
  anchor.click();
  URL.revokeObjectURL(url);
  return count;
}
